import { usePage, Link } from '@inertiajs/react'
import { useCan } from '@/shared/hooks/useCan'
import { Resources, Actions } from '@/shared/rbac'
import { t } from '@/shared/lib/i18n'
import { adminUserPath, notificationPreferencesAdminUserPath } from '@/shared/lib/routes'
import type { SharedProps } from '@/shared/types/SharedProps'
import type WebNotificationPreferencesPage from '@/shared/types/web/WebNotificationPreferencesPage'
import PreferenceForm from '@/pages/NotificationPreferences/PreferenceForm'

interface AdminNotificationPreferencesProps {
  user: { id: number; fullName: string }
  notificationPreferencesPage: WebNotificationPreferencesPage
}

type PageProps = SharedProps & AdminNotificationPreferencesProps

const AdminUserNotificationPreferences = () => {
  const { user, notificationPreferencesPage } = usePage<PageProps>().props
  // REBUILD-484: admin management is gated by the users-admin resource, not the self-service one.
  const canSubmit = useCan(Resources.ADMIN_USER, Actions.UPDATE)

  return (
    <div className="mx-auto max-w-3xl space-y-6 px-4 py-8">
      <header className="space-y-1">
        <h1 className="text-2xl font-semibold tracking-tight">
          {t('admin.users.notificationPreferences.pageTitle', { name: user.fullName })}
        </h1>
        <p className="text-sm text-muted-foreground">
          {t('admin.users.notificationPreferences.pageSubtitle')}
        </p>
        <Link href={adminUserPath(user.id)} className="text-sm text-primary hover:underline">
          {t('admin.users.notificationPreferences.backToUser')}
        </Link>
      </header>

      <PreferenceForm
        notificationPreferencesPage={notificationPreferencesPage}
        patchPath={notificationPreferencesAdminUserPath(user.id)}
        canSubmit={canSubmit}
      />
    </div>
  )
}

export default AdminUserNotificationPreferences
